import api from "../../Api/feathers-client";

// Call backend service to get asset
export const getAssets = async (assetUid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assets").find({
        query: {
          $select: ["asset_name", "asset_uid", "content"],
          asset_uid: {
            $in: assetUid,
          },
        },
      });

      resolve({
        status: 200,
        message: "Asset Data",
        data: response.data,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getUserLog = async (queryData) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find({
        query: queryData,
      });

      resolve({
        status: 200,
        message: "User-logs Get",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const updateLog = async (data, query) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").patch(null, data, {
        query: query,
      });

      console.log("response", response);
      if (response.length == 0) {
        resolve({
          status: 404,
          message: "Not found",
        });
      }
      resolve({
        status: 200,
        message: "Log updated successfully.",
      });
    } catch (error) {
      resolve({
        status: 500,
        message: error.message,
      });
    }
  });
};

export const removeUploadedAudio = async (files) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("tasks").remove("", {
        query: {
          files: files,
        },
      });

      resolve({
        status: 200,
        message: "Files Deleted",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getAllAssignedBooks = async (queryData) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("tasks").find({
        query: queryData,
      });

      resolve({
        status: 200,
        message: "Books",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const removeUploadedAudioOfBook = async (files) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("remove-uploaded-file").remove("", {
        query: {
          files: files,
        },
      });

      resolve({
        status: 200,
        message: "Files Deleted",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
